import { cardRecipe } from '../../design/recipes/card';
import { paperRecipe } from '../../design/recipes/paper';
import { toMuiVariants } from '../../design/toMuiVariants';

export const getSurfacesOverrides = (theme) => ({
    MuiCard: {
      variants: toMuiVariants(cardRecipe),
    },

    // ── Paper (layout shells — filter panels, action rows) ──
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      variants: toMuiVariants(paperRecipe),
    },
    MuiAccordion: {
        styleOverrides: {
          root: {
            margin: 0,
            "&.Mui-expanded": {
              margin: 0,
            },
          },
        },
      },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            outline: `3px solid ${theme.palette.accent.butterscotch}`,
            outlineOffset: theme.spacing(0.25),
          },
        },
      },
    },
});
